import { render } from "./index.vue?vue&type=template&id=4ba2c270&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=4ba2c270&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-4ba2c270"

export default script